// src/mocks/listings.mock.js

// MOCK aislado para pruebas.
// 👉 Cada listing tiene:
// - id   (numérico, PK en DB, rápido para joins)
// - slug (string único, para URL legible/SEO)
//
// Frontend usa slug en rutas públicas, pero también soporta id
// para debug/backend. Ejemplo:
//   /listing/caja-seca-53-reefer-mty
//   /listing/id/13

export const LISTINGS_MOCK = [
  {
    id: 13,
    slug: 'caja-seca-53-reefer-mty',
    titulo: 'Caja seca 53" con opción refrigerada – Servicio nacional',
    categoria: 'FTL / Medio y Larga Distancia',
    proveedor: {
      slug: 'unitrans-logistics',
      nombre: 'UniTrans Logistics',
      logo: 'https://via.placeholder.com/96x96.png?text=UT',
      anios: 7,
      rfcMasked: 'UTL9***12A',
      telefono: '+52 81 1234 5678',
      contacto: 'operaciones@unitrans.mx',
      verificado: true,
      nps: 72,
      baseOperacion: 'Monterrey, N.L.',
      docs: [
        { key:'acta', label:'Acta constitutiva', ok:true },
        { key:'rfc', label:'RFC', ok:true },
        { key:'domicilio', label:'Comprobante de domicilio', ok:true },
        { key:'licencia', label:'Licencia de funcionamiento', ok:false },
      ]
    },
    rating: 4.6,
    reviews: [
      { author: 'María G.', rating: 5, comment: 'Puntuales y cuidadosos con la carga.' },
      { author: 'Luis P.', rating: 4, comment: 'Buena comunicación en tránsito.' }
    ],
    imagenes: [
      'https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?auto=format&fit=crop&w=1200&q=80'
    ],
    baseOperacion: 'Monterrey, N.L.',
    cobertura: {
      nacional: true,
      estados: ['N.L.', 'Tamps.', 'Coah.', 'CDMX', 'EdoMex'],
      ultimaMilla: false
    },
    unidad: {
      tipo: 'Tractor + Caja',
      carroceria: 'Caja seca 53"',
      ano: 2022,
      placas: '12-ABC-3',
      gps: true,
      liftgate: true,
    },
    precio: {
      moneda: 'MXN',
      minimo: 5500,
      porKm: 38
    }
  },
  {
    id: 14,
    slug: 'torton-cdmx-distribucion',
    titulo: 'Torton 10 toneladas – Distribución local CDMX y EdoMex',
    categoria: 'LTL / Última Milla',
    proveedor: {
      slug: 'express-del-valle',
      nombre: 'Express del Valle',
      logo: 'https://via.placeholder.com/96x96.png?text=EV',
      anios: 12,
      rfcMasked: 'EDV7***91B',
      telefono: '+52 55 5566 7788',
      contacto: 'contacto@expressvalle.mx',
      verificado: true,
      nps: 65,
      baseOperacion: 'CDMX',
      docs: [
        { key:'acta', label:'Acta constitutiva', ok:true },
        { key:'rfc', label:'RFC', ok:true },
        { key:'ine', label:'INE representante', ok:true },
      ]
    },
    rating: 4.3,
    reviews: [
      { author: 'Carlos H.', rating: 5, comment: 'Excelente trato y puntualidad.' }
    ],
    imagenes: [
      'https://images.unsplash.com/photo-1585123334904-fb9c8b6c4b1c?auto=format&fit=crop&w=1200&q=80'
    ],
    baseOperacion: 'CDMX',
    cobertura: {
      nacional: false,
      estados: ['CDMX', 'EdoMex', 'Hgo', 'Pue'],
      ultimaMilla: true
    },
    unidad: {
      tipo: 'Torton',
      carroceria: 'Caja seca 10t',
      ano: 2020,
      placas: 'CDX-45-67',
      gps: true,
      liftgate: false,
    },
    precio: {
      moneda: 'MXN',
      minimo: 3500,
      porKm: 25
    }
  },
  {
    id: 15,
    slug: 'plataforma-40ft-gdl',
    titulo: 'Plataforma 40 pies – Rutas Bajío y Occidente',
    categoria: 'FTL / Carga Especializada',
    proveedor: {
      slug: 'trans-bajio',
      nombre: 'TransBajío',
      logo: 'https://via.placeholder.com/96x96.png?text=TB',
      anios: 5,
      rfcMasked: 'TBJ1***33C',
      telefono: '+52 33 3344 5566',
      contacto: 'ventas@transbajio.mx',
      verificado: false,
      nps: 58,
      baseOperacion: 'Guadalajara, Jal.',
      docs: [
        { key:'acta', label:'Acta constitutiva', ok:true },
        { key:'rfc', label:'RFC', ok:true }
      ]
    },
    rating: 4.1,
    reviews: [
      { author: 'Ana L.', rating: 4, comment: 'Cumplen, aunque algo tardados en confirmar.' }
    ],
    imagenes: [
      'https://images.unsplash.com/photo-1611911816325-2cf1a64eab2b?auto=format&fit=crop&w=1200&q=80'
    ],
    baseOperacion: 'Guadalajara, Jal.',
    cobertura: {
      nacional: true,
      estados: ['Jal', 'Gto', 'Qro', 'Mich'],
      ultimaMilla: false
    },
    unidad: {
      tipo: 'Tracto + Plataforma',
      carroceria: 'Plataforma 40ft',
      ano: 2021,
      placas: 'JAL-99-01',
      gps: true,
      liftgate: false,
    },
    precio: {
      moneda: 'MXN',
      minimo: 4800,
      porKm: 32
    }
  }
];
